import { tabletQuery } from '@globals/themes/themeConstants'
import { TenantMemberDisplayData } from '@kudos/http-client'
import StarOutlineRoundedIcon from '@mui/icons-material/StarOutlineRounded'
import Button from '@mui/material/Button'
import { SxProps } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import useMobileRecognitionDrawer from '@tenant/recognition/MobileRecognition/useMobileRecognitionDrawer'
import useRecognitionModal, {
  RecognitionModalViews,
} from '@tenant/recognition/RecognitionModal/useRecognitionModal'
import { T, useT } from '@transifex/react'
import { ReactNode } from 'react'

type RecognizeButtonProps = {
  recipient?: TenantMemberDisplayData
  variant?: 'text' | 'outlined' | 'contained'
  fullWidth?: boolean
  sx?: SxProps
  id?: string
  startIcon?: ReactNode
  'aria-label'?: string
  onRecognized?: () => void
  stopPropagation?: boolean
}

const RecognizeButton: React.FC<RecognizeButtonProps> = ({
  recipient,
  variant = 'contained',
  fullWidth,
  sx,
  id = 'btnRecognize',
  startIcon = <StarOutlineRoundedIcon />,
  'aria-label': ariaLabel,
  onRecognized,
  stopPropagation = false,
}) => {
  const t = useT()
  const isTablet = useMediaQuery(tabletQuery)
  const { openDialog } = useRecognitionModal()
  const { openDrawer } = useMobileRecognitionDrawer()

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (stopPropagation) {
      event.stopPropagation()
    }

    const recipients = recipient ? [recipient] : undefined

    if (isTablet) {
      openDrawer({ recipients })
    } else {
      openDialog({
        view: RecognitionModalViews.SendRecognition,
        recipients,
      })
    }

    event.currentTarget.blur()
    onRecognized?.()
  }

  return (
    <Button
      id={id}
      variant={variant}
      fullWidth={fullWidth}
      sx={sx}
      startIcon={startIcon}
      onClick={handleClick}
      aria-label={ariaLabel ?? t('Send recognition')}>
      <T _str="Recognize" />
    </Button>
  )
}

export default RecognizeButton
